module.exports = __webpack_public_path__ + "img/dante-menu.1e610fb1.jpg";